/* eslint-disable global-require */
import polyfill from './polyfill';

polyfill(() => {
  require('./app-pub');
});



// WEBPACK FOOTER //
// ./src/index-pub.jsx